export const bonus_buy_dialog = (t) => ({
	BONUS_BUY_DIALOG_HEADER: {
		value: 'BONUS BUY',
		config: {
			fontFamily: 'Japanese',
			fontSize: 50,
			letterSpacing: 2,
			fill: ['#F8EFD7', '#F8EFD7'],
			stroke: '#CA9E38',
			strokeThickness: 2
		}
	},

	BONUS_TRIGGER_TEXT: {
		value: 'BONUS SPINS',
		config: {
			fontFamily: 'Japanese',
			fontSize: 45,
			letterSpacing: 2,
			fill: ['#F8EFD7', '#F8EFD7'],
			stroke: '#CA9E38',
			strokeThickness: 2
		}
	},
	BONUS_TRIGGER_AMOUNT: {
		value: '+10',
		config: {
			fontFamily: 'Japanese',
			fontSize: 85,
			letterSpacing: 2,
			fill: ['#F8EFD7', '#F8EFD7'],
			stroke: '#CA9E38',
			strokeThickness: 2
		}
	},
	BONUS_BUY_DIALOG_DESCRIPTION_0: {
		value: t('bonusBuyDialog.bonus_buy_dialog_description_0'),
		config: {
			fill: '#EED999',
			fontFamily: 'Poppins SemiBold',
			fontSize: 28
		}
	},
	BONUS_BUY_DIALOG_FREESPIN_AMOUNT: {
		value: '0',
		config: {
			fontFamily: 'Japanese',
			fontSize: 44,
			fill: ['#F8EFD7', '#F8EFD7'],
			stroke: '#CA9E38',
			strokeThickness: 2
		}
	},
	BONUS_BUY_DIALOG_DESCRIPTION_1: {
		value: t('bonusBuyDialog.bonus_buy_dialog_description_1'),
		config: {
			fill: '#EED999',
			fontFamily: 'Poppins SemiBold',
			fontSize: 28
		}
	},
	BONUS_BUY_DIALOG_FREESPIN_COST: {
		value: '$200',
		config: {
			lineHeight: 1,
			fontFamily: 'Japanese',
			fontSize: 60,
			fill: ['#F8EFD7', '#F8EFD7'],
			stroke: '#CA9E38',
			strokeThickness: 2
		}
	},
	BONUS_BUY_DIALOG_YES_BTN: {
		value: 'YES',
		config: {
			fill: '#FAF6E4',
			fontFamily: 'Poppins SemiBold',
			fontSize: 34
		}
	},
	BONUS_BUY_DIALOG_NO_BTN: {
		value: 'NO',
		config: {
			fill: '#FAF6E4',
			fontFamily: 'Poppins SemiBold',
			fontSize: 34
		}
	},
	BONUS_TRIGGERED: {
		value: t('bonus.bonus_triggered')
	},
	BONUS_SPINS_LEFT: {
		value: t('bonus.bonus_spins_left')
	},
	WIN: {
		value: t('bonus.win')
	}
});
